<div class="title">{{ 'batchUpload.title' | localize }}</div>

<div class="tabs">
  <ul>
    <li [ngClass]="{'is-active': isUploadVisible()}"><a (click)="showUploadClicked()">{{ 'batchUpload.tabs.uploadBatch' | localize }}</a></li>
    <li [ngClass]="{'is-active': !isUploadVisible()}"><a (click)="showListClicked()">{{ 'batchUpload.tabs.listBatches' | localize }}</a></li>
  </ul>
</div>

<div>
  <div class="columns" [ngClass]="{'is-hidden': !isUploadVisible()}">
    <div class="column is-10 is-offset-1">
      <app-claim-file-uploads
        [config]="batchUploadFilesConfig"
        [presignedUrlSupplier]="getBatchUploadPresignedUrls.bind(this)"
        [claimId]="'claimId'"
        (filesUploadingChange)="onBatchUploadFilesUploading($event)"
      >
      </app-claim-file-uploads>
    </div>
  </div>

  <div [ngClass]="{'is-hidden': isUploadVisible()}">
    <div class="container">
      @for (batch of batches; track batch.batchId; let i = $index; let isLast = $last) {
        <div [ngClass]="{'pb-2': !isLast}">
        <app-single-single-batch-upload-metadata [batchUploadMetadata]="batch"/>
        </div>
      }
    </div>
  </div>
</div>









